import React, { FunctionComponent, useContext, useEffect, useState } from 'react';
import styles from './DirectoryCard.module.scss';
import { DirectoryListType } from '../../directory-list/DirectoryList';
import { AppContext } from '../../../context/AppContext';
import { IDirectoryButtonProps } from '../../directory-button-area/directory-button/DirectoryButton';

export interface IDirectoryCardProps {
  title: string;
  listType: DirectoryListType;
  currentListType: DirectoryListType;
}

const DirectoryCard: FunctionComponent<IDirectoryCardProps> = ({ title, currentListType, listType, children }) => {
  const appContext = useContext(AppContext);
  useEffect(() => {
    if (currentListType === listType) {
      appContext.updateListType(listType);
    }
  });
  return (
    <button
      className={`${styles.directoryCard}${appContext.isDirectorySelected && currentListType === listType ? ' ' + styles.isActive : ''}`}
      onClick={() => {
          appContext.updateListType(listType);
          appContext.updateSelected(true);
      }}
    >
      <div>{children}</div>
      <div className={styles.cardText}>{title}</div>
    </button>
  );
};

export default DirectoryCard;
